<template>
	<div class="relative block" :class="{divided: props.divided}">
		<div class="flex px-16 lg:px-24"
			 :class="{'items-center': props.centered, 'py-16 md:py-20': props.divided && !$slots.below, 'pt-16 md:pt-20 pb-8': props.divided && $slots.below}">
			<div v-if="props.image" class="mr-14 sm:mr-20 mt-2">
				<skeleton :height="props.imageWidth / props.imageRatio" :width="props.imageWidth" :rounded-full="props.imageRatio === 1" :rounded="props.imageRatio !== 1"/>
			</div>

			<div class="flex-grow-x-1 overflow-hidden">
				<div class="flex overflow-hidden">
					<div class="flex flex-column flex-grow-1" :class="{'justify-center': props.centered, 'mb-4': props.description || $slots.default}">
						<skeleton v-if="props.title" height="14" :width="150" rounded class="mb-8 mt-2"/>
						<skeleton v-if="props.subtitle" height="12" :width="130" rounded class="mb-2"/>
					</div>
					<div v-if="$slots.right" class="flex justify-end text-right ml-8" :class="{'items-center': props.centered}">
						<slot name="right"/>
					</div>
				</div>

				<paragraph-skeleton v-if="props.description" small :class="[$slots.default ? 'mb-8' : 'mb-1']"/>

				<slot/>
			</div>
		</div>
		<slot name="below"/>

	</div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
	// Whether to display a skeleton for the title slot
	title?: boolean,

	// Whether to display a skeleton for the subtitle slot
	subtitle?: boolean,

	// Whether to display a skeleton for the description slot
	description?: boolean,

	// Whether the resource item shall get additional spacing and multiple items shall be
	// divided with a border
	divided?: boolean,

	// Whether to center all items vertically
	centered?: boolean,

	// Whether to display a skeleton for the image slot
	image?: boolean,
	imageRatio?: number,
	imageWidth?: number,
}>(), {
	imageWidth: 40,
	imageRatio: 1
});
</script>

